import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, UserPlus } from "lucide-react";
import { api, errMsg } from "../lib/api";

const inp = "mt-1 mb-4 w-full rounded-sm border border-[#E2E8F0] bg-white px-3 py-2 text-sm outline-none focus:border-blue-600";
const lbl = "text-[10px] uppercase tracking-widest text-slate-500";

export default function Register() {
  const [f, setF] = useState({ name: "", email: "", password: "", note: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await api.post("/auth/register", f); setDone(true); } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="grain flex min-h-screen items-center justify-center bg-[#F8FAFC] p-5">
      <div className="panel w-full max-w-sm bg-white p-6 fade-up" data-testid="register-card">
        <Link to="/welcome" className="mb-5 flex items-center gap-2 font-display text-xs font-extrabold" data-testid="register-home-link"><img src="/logo.svg" alt="DMI" className="h-7 w-7" />DMI <span className="text-blue-600">SHARE</span> INVESTMENT</Link>
        {done ? (
          <div data-testid="register-success">
            <CheckCircle2 className="h-8 w-8 text-emerald-600" />
            <h2 className="mt-3 font-display text-lg font-bold">Permohonan dihantar</h2>
            <p className="mt-2 text-sm text-slate-600">Akaun anda menunggu kelulusan pemilik. Selepas diluluskan, log masuk dengan emel dan kata laluan yang sama.</p>
            <Link to="/login" className="mt-5 inline-block text-sm text-blue-600 underline" data-testid="register-go-login">Ke halaman log masuk</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="register-form">
            <div className="mb-5 flex items-center gap-2"><UserPlus className="h-5 w-5 text-blue-600" /><h2 className="font-display text-lg font-bold">Mohon akses dashboard signal</h2></div>
            <label className={lbl}>Nama</label><input data-testid="register-name-input" required minLength={2} value={f.name} onChange={set("name")} className={inp} />
            <label className={lbl}>Emel</label><input data-testid="register-email-input" required type="email" value={f.email} onChange={set("email")} className={inp} />
            <label className={lbl}>Kata laluan (min 8 aksara)</label><input data-testid="register-password-input" required type="password" minLength={8} value={f.password} onChange={set("password")} className={inp} />
            <label className={lbl}>Nota kepada pemilik (pilihan)</label><textarea data-testid="register-note-input" maxLength={300} rows={2} value={f.note} onChange={set("note")} className={inp} />
            {err && <div data-testid="register-error" className="mb-3 rounded-sm border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-600">{err}</div>}
            <button data-testid="register-submit-button" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-sm bg-blue-600 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 disabled:opacity-60">{busy && <Loader2 className="h-4 w-4 animate-spin" />}Hantar permohonan</button>
            <p className="mt-4 text-[11px] text-slate-500">Sudah diluluskan? <Link to="/login" className="text-blue-600 underline" data-testid="register-login-link">Log masuk</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
